// extracted by mini-css-extract-plugin
export var chip = "_5m-9";
export var chipLabel = "_5m-a";
export var close = "_5m-7";
export var closeIcon = "_5m-8";
export var error = "_5m-6";
export var infoTooltip = "_5m-2";
export var innerContainer = "_5m-1";
export var input = "_5m-b";
export var medium = "_5m-5";
export var outerContainer = "_5m-0";
export var small = "_5m-4";
export var xSmall = "_5m-3";